/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { TagSet_Enum, tagSet_EnumFromJSON, tagSet_EnumToJSON } from "../../../../gen/common/tag_set";

export const protobufPackage = "skills";

export interface ApriltagSetIdActionArgs {
  timeoutS: number;
}

export interface ApriltagSetIdResultData {
  tagSet: TagSet_Enum;
}

export interface ApriltagSetIdActionStateData {
}

function createBaseApriltagSetIdActionArgs(): ApriltagSetIdActionArgs {
  return { timeoutS: 0 };
}

export const ApriltagSetIdActionArgs = {
  encode(message: ApriltagSetIdActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.timeoutS !== 0) {
      writer.uint32(13).float(message.timeoutS);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ApriltagSetIdActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseApriltagSetIdActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 13) {
            break;
          }

          message.timeoutS = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ApriltagSetIdActionArgs {
    return { timeoutS: isSet(object.timeoutS) ? globalThis.Number(object.timeoutS) : 0 };
  },

  toJSON(message: ApriltagSetIdActionArgs): unknown {
    const obj: any = {};
    if (message.timeoutS !== 0) {
      obj.timeoutS = message.timeoutS;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ApriltagSetIdActionArgs>, I>>(base?: I): ApriltagSetIdActionArgs {
    return ApriltagSetIdActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ApriltagSetIdActionArgs>, I>>(object: I): ApriltagSetIdActionArgs {
    const message = createBaseApriltagSetIdActionArgs();
    message.timeoutS = object.timeoutS ?? 0;
    return message;
  },
};

function createBaseApriltagSetIdResultData(): ApriltagSetIdResultData {
  return { tagSet: 0 };
}

export const ApriltagSetIdResultData = {
  encode(message: ApriltagSetIdResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.tagSet !== 0) {
      writer.uint32(8).int32(message.tagSet);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ApriltagSetIdResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseApriltagSetIdResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.tagSet = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ApriltagSetIdResultData {
    return { tagSet: isSet(object.tagSet) ? tagSet_EnumFromJSON(object.tagSet) : 0 };
  },

  toJSON(message: ApriltagSetIdResultData): unknown {
    const obj: any = {};
    if (message.tagSet !== 0) {
      obj.tagSet = tagSet_EnumToJSON(message.tagSet);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ApriltagSetIdResultData>, I>>(base?: I): ApriltagSetIdResultData {
    return ApriltagSetIdResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ApriltagSetIdResultData>, I>>(object: I): ApriltagSetIdResultData {
    const message = createBaseApriltagSetIdResultData();
    message.tagSet = object.tagSet ?? 0;
    return message;
  },
};

function createBaseApriltagSetIdActionStateData(): ApriltagSetIdActionStateData {
  return {};
}

export const ApriltagSetIdActionStateData = {
  encode(_: ApriltagSetIdActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ApriltagSetIdActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseApriltagSetIdActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ApriltagSetIdActionStateData {
    return {};
  },

  toJSON(_: ApriltagSetIdActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<ApriltagSetIdActionStateData>, I>>(base?: I): ApriltagSetIdActionStateData {
    return ApriltagSetIdActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ApriltagSetIdActionStateData>, I>>(_: I): ApriltagSetIdActionStateData {
    const message = createBaseApriltagSetIdActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
